import { render, staticRenderFns } from "./appointManage.vue?vue&type=template&id=42ba2172&scoped=true"
import script from "./appointManage.vue?vue&type=script&lang=js"
export * from "./appointManage.vue?vue&type=script&lang=js"
import style0 from "./appointManage.vue?vue&type=style&index=0&id=42ba2172&prod&lang=scss&scoped=true"
import style1 from "./appointManage.vue?vue&type=style&index=1&id=42ba2172&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42ba2172",
  null
  
)

export default component.exports